import watchFonts from './fonts'

// JS needed for rendering
// Note: jQuery is not available at this point
watchFonts()
